// extracted by mini-css-extract-plugin
export var content = "_mo-1";
export var fullScreen = "_mo-0";